'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { TestimonalsSection } from '@/features/client/TestimonalsSection/TestimonalsSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';

const ServicesPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary">
        <MainSection
          label="Our Service"
          title="Explore Our Home Solutions & Services"
          description=""
        />
      </MainSectionLayout>
      <Section variant="primary">
        <Container>
          <ServiceCardsSection />
        </Container>
      </Section>
      <Section variant="primary">
        <Container>
          <TestimonalsSection />
        </Container>
      </Section>
      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default ServicesPage;
